import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { useNavigate, Link } from "react-router-dom";
import { Bell } from "lucide-react";

export default function Notifications() {
  const { user, ready } = useAuth();
  const nav = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/me/notifications").then(r=>setList(r.data));
    api.post("/me/notifications/read").catch(()=>{});
  }, [user]);

  if (ready && !user) { nav("/login"); return null; }

  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 pt-6">
      <h1 className="h-font text-3xl font-bold flex items-center gap-2"><Bell size={22}/> Notifications</h1>
      <div className="mt-6 space-y-2">
        {list.length===0 && <div className="text-white/50 text-sm">All caught up.</div>}
        {list.map(n => (
          <div key={n.id} className={`p-4 rounded-xl border ${n.read?'border-white/5 bg-white/[0.02]':'border-[#08D9D6]/30 bg-[#08D9D6]/5'}`}>
            <div className="text-sm">{n.video_id ? <Link to={`/watch/${n.video_id}`} data-testid={`notif-link-${n.id}`} className="hover:text-[#00E7FF]">{n.text}</Link> : n.text}</div>
            <div className="text-xs text-white/50 mt-1">{new Date(n.created_at).toLocaleString()} · {n.type}</div>
          </div>
        ))}
      </div>
      <Link to="/" className="text-[#08D9D6] text-sm mt-6 inline-block">← Back home</Link>
    </div>
  );
}
